import type { PictureSources } from '@/types/Media'
import { env } from '@/config/env'
import { getPictureSources } from '@/services/media/imageRegistry'

export function storagePathToUrl(path: string): string {
  const bucket = env.firebase.storageBucket
  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(path)}?alt=media`
}

function resolveUrl(value: string): string {
  if (value.startsWith('http://') || value.startsWith('https://')) return value
  return storagePathToUrl(value)
}

export function urlToPictureSources(urlOrPath: string): PictureSources {
  const url = resolveUrl(urlOrPath)
  return {
    fallback: url,
    sources: [{ type: guessContentType(urlOrPath), srcset: url }]
  }
}

/**
 * Resolves a content image reference to PictureSources.
 * When firebaseCms is ON, the value is a storage path; when OFF, it's an image registry key.
 */
export function resolveContentImage(imageRef: string): PictureSources | undefined {
  if (!imageRef) return undefined
  if (env.features.firebaseCms) {
    return urlToPictureSources(imageRef)
  }
  return getPictureSources(imageRef)
}

function guessContentType(url: string): string {
  const lower = url.toLowerCase()
  if (lower.includes('.avif')) return 'image/avif'
  if (lower.includes('.webp')) return 'image/webp'
  if (lower.includes('.png')) return 'image/png'
  // Default to JPEG — Firebase Storage URLs often lack a recognizable extension
  return 'image/jpeg'
}
